import request from '@/utils/request';

export default {
  /**
   * execute payment
   */
  executePayment: (params: object) => request.post('/pay_pal_orders', params),
};
